import Link from "plos/src/components/links/Link/Link";
import { copy } from "plos/src/styles/copy.css";
import { Trans } from "react-i18next";

const LeaguesHelp = () => (
  <div className={copy}>
    <Trans ns="help" i18nKey="contextualHelp.leagues.description">
      <p>
        Creating or joining a league allows you to compete against friends,
        family or colleagues. You could join a private invitational league
        created by friends or a public league based on your interests.
      </p>
      <p>
        League positions change each Gameweek depending on points scored, with
        green and red arrows marking your progress for that Gameweek.
      </p>
      <p>
        Leagues can also be set up as head-to-head competitions, where managers
        face one opponent per Gameweek and score points for a win or draw.
      </p>
      <p>
        Each league also has a cup, which is a knockout competition where
        managers compete head-to-head in a Gameweek. The manager with the
        highest score progresses to the next round.
      </p>
      <Link
        href={`${
          import.meta.env.VITE_HF_BASE
        }/en/news/2174934/fpl-basics-leagues-and-cups`}
      >
        FPL Basics Explained: Leagues & Cups
      </Link>
    </Trans>
  </div>
);

export default LeaguesHelp;
